import {
   ApiResponse,
   createApiRequest,
   Header,
   getHeaderFromSessionStorage,
} from "@/api"
import { ClearAlertForm } from "@/components/AlertModal/ClearAlert/Form"
import { API_URL, Endpoints } from "@/constants/endpoints"
import { HttpMethods } from "@/constants/globals"
import {
   AlertConfiguration,
   AlertInmate,
   AlertLevel,
   AlertSource,
   AlertVitals,
   ProcessingMethod,
   ThresholdValue,
} from "@/types/alert"

export enum ThresholdType {
   HEART_RATE = "heartRate",
   RESPIRATORY_RATE = "respiratoryRate",
   OXYGEN_LEVEL = "oxygenLevel",
}

export interface AlertThresholdResponse {
   type: ThresholdType
   processingMethod: ProcessingMethod
   high: ThresholdValue
   low: ThresholdValue
}

export interface AlertResponse {
   id: string
   source?: AlertSource
   level: AlertLevel
   inmate?: AlertInmate
   priority: number
   timestamp: string
   vitals: AlertVitals
   alertConfiguration: AlertConfiguration
   thresholds: AlertThresholdResponse[]
}

export interface TriggerTestAlertResponse {
   id: string
}

export async function requestAlertsByLevel(
   levelId: string
): Promise<ApiResponse<AlertResponse[]>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.ALERTS}${levelId}/`,
      HttpMethods.GET,
      null,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}

export async function requestTriggerTestAlert(
   levelId: string
): Promise<ApiResponse<TriggerTestAlertResponse>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.ALERTS}`,
      HttpMethods.POST,
      { levelId },
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}

export async function requestClearAlert(
   alertId: string,
   clearReport: ClearAlertForm,
   levelId?: string
): Promise<ApiResponse<void>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.ALERTS}${alertId}/`,
      HttpMethods.PATCH,
      { ...(levelId ? { levelId } : {}), ...clearReport },
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}

export async function requestClearAlerts(
   clearReport: Partial<ClearAlertForm>
): Promise<ApiResponse<void>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.ALERTS}clear/`,
      HttpMethods.PATCH,
      { ...clearReport },
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}
